import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-metro-list-card-item',
  templateUrl: './metro-list-card-item.component.html',
  standalone:false
})
export class MetroListCardItemComponent {
  @Input() productName: string = 'Bodega del Sol';
  @Input() items: number = 1;
  @Input() year: string = '2024';
  @Input() country: string = 'Argentina';
  @Input() price: number = 85.0;
  @Input() imageUrl: string = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTrKz7M8DJcvzguBhnOjQq_xUVpv_bxz26ycg&s';
  @Input() isLoading: boolean = false;
  @Input() maxAvailable: number = 0;  // Propiedad para indicar stock disponible
  @Input() showDeleteButton: boolean = true;  // Flag para mostrar/ocultar el botón de eliminar

  @Output() itemsChange = new EventEmitter<{quantity: number, loading: boolean, checkForNewStock?: boolean}>();
  @Output() removeItem = new EventEmitter<{quantity: number, loading: boolean}>();
  @Output() deleteItem = new EventEmitter<{quantity: number, loading: boolean}>();

  // Calcular si estamos en stock máximo
  get isAtMaxStock(): boolean {
    return this.items >= this.maxAvailable && this.maxAvailable > 0;
  }

  increment() {
    if (!this.isLoading) {
      // Si estamos en el máximo y se intenta incrementar, emitimos un evento especial
      // para que el componente padre verifique si hay nuevo stock
      if (this.items >= this.maxAvailable) {
        this.itemsChange.emit({quantity: this.items, loading: true, checkForNewStock: true});
      } else {
        this.items++;
        this.itemsChange.emit({quantity: this.items, loading: true});
      }
    }
  }

  decrement() {
    if (this.items > 1 && !this.isLoading) {
      this.items--;
      this.itemsChange.emit({quantity: this.items, loading: true});
    } else if (this.items === 1 && !this.isLoading) {
      // Si es el último elemento, emitir evento para eliminar el ítem
      this.removeItem.emit({quantity: 0, loading: true});
    }
  }

    onImageError(event: Event) {
  const target = event.target as HTMLImageElement;
  target.src = 'assets/images/no-image.png'; // ruta a tu imagen por defecto
}

  deleteItemFromCart() {
    if (!this.isLoading) {
      // Emitir evento para eliminar el ítem
      this.deleteItem.emit({quantity: 0, loading: true});
    }
  }
}
